export const brand = {
  wordmark:
    'https://cdn.magicpatterns.com/uploads/ppY4tPBdwodPDmeuodkwiQ/LetLois_Logo_Wide_Lapels_Blue_Transparent_(2).png',
  mark:
    'https://cdn.magicpatterns.com/uploads/7VyHUCEMtuHDrcDWUNdw5g/LetLois_Logo_Woman_Wide_Lapels_Blue_Transparent.png',
  onboardingUrl: 'start.letlois.com',
  supportEmail: 'support@letlois.com',
}
